import Banner from "components/common/Banner";
import AchievementsOverlay from "components/Achievements/AchievementsOverlay";
import AchievementsOverlayMobile from "components/Achievements/AchievementsOverlay/AchievementsOverlayMobile";

import envs from "config/envs";

const AchievementsBanner = () => {
  return (
    <section role="banner">
      <Banner
        background={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_achievements.webp`}
        width="100vw"
        height="45vw"
      >
        <Banner.Overlay center={false}>
          <AchievementsOverlay />
        </Banner.Overlay>
      </Banner>

      <Banner
        mobileBackground={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_achievements_mobile.webp`}
        width="100vw"
        height="130vw"
        isMobile
      >
        <Banner.Overlay center={false} isMobile>
          <AchievementsOverlayMobile />
        </Banner.Overlay>
      </Banner>
    </section>
  );
};

export default AchievementsBanner;
